import React from "react";
import { css } from "@linaria/core";
import { fonts } from "@ui/Theme";
import t from "../../i18n";
import useSetupMode from "./useSetupMode";
import { setupModeColors } from "./colors";

export default function SetupModeBanner() {
  const { isSetupModeEnabled } = useSetupMode();

  if (!isSetupModeEnabled) return null;

  return (
    <div className={setupModeBanner} role="status">
      <p>{t("hamburger.setup_mode")}</p>
    </div>
  );
}

const setupModeBanner = css`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 24px;
  padding: 3px 16px;
  background-color: ${setupModeColors.background};
  pointer-events: none;

  p {
    margin: 0;
    font: ${fonts.body2SemiBold};
    color: ${setupModeColors.primary};
  }
`;
